import { useFormikContext } from 'formik'

export function useData() {
  const { isValid, isSubmitting } = useFormikContext()
  const disableSave = !isValid || isSubmitting

  return {
    disableSave,
  }
}
